import React from 'react';
import { CdnIcon } from '@shared/ui';
import { FareFamilyOptionsType, FareFeaturePaymentType } from '@websky/graphql';
export const getFareOptionTooltipTitle = (title, shortDescription) => shortDescription ? `${title} - ${shortDescription}` : title;
export const getOptionTitle = ({ title, value, size, isKeyOption, variant }) => {
    let resultTitle = '';
    if (variant === 'small') {
        if (isKeyOption) {
            /** Для опций в плитках */
            resultTitle = value || title;
        }
        else {
            /** Для опций в списке */
            resultTitle = title;
        }
    }
    if (variant === 'big') {
        resultTitle = [value, size].filter(Boolean).join(',\n') || title;
    }
    return resultTitle;
};
export const renderFeaturePaymentTypeIcon = (type) => {
    const icons = {
        [FareFeaturePaymentType.Free]: React.createElement(CdnIcon, { icon: "Info/Item Icluded" }),
        [FareFeaturePaymentType.Pay]: React.createElement(CdnIcon, { icon: "Info/Item Paid" }),
        [FareFeaturePaymentType.NotAvailable]: React.createElement(CdnIcon, { icon: "Info/Not included" })
    };
    return icons[type];
};
export const renderFareOptionsTypeIcon = (type) => {
    const icons = {
        [FareFamilyOptionsType.VipService]: React.createElement(CdnIcon, { icon: "Services/Business Lounge" }),
        [FareFamilyOptionsType.CarryOn]: React.createElement(CdnIcon, { icon: "Baggage/Cabin" }),
        [FareFamilyOptionsType.Baggage]: React.createElement(CdnIcon, { icon: "Baggage/Checked-in" }),
        [FareFamilyOptionsType.SeatRegistration]: React.createElement(CdnIcon, { icon: "Services/Seat Selection" }),
        [FareFamilyOptionsType.Meal]: React.createElement(CdnIcon, { icon: "Services/Meal" }),
        [FareFamilyOptionsType.Refundable]: React.createElement(CdnIcon, { icon: "Services/Refundable" }),
        [FareFamilyOptionsType.Exchangeable]: React.createElement(CdnIcon, { icon: "Services/Exchangeable" }),
        [FareFamilyOptionsType.SportsEquipment]: React.createElement(CdnIcon, { icon: "Baggage/Sport Equipment" }),
        [FareFamilyOptionsType.OnlineRegistration]: React.createElement(CdnIcon, { icon: "Document/Boarding pass" })
    };
    return icons[type];
};
